import { getApiActionTypesValues } from '../redux_utils';

const USER_PAYMENT_FLOW = {
  FETCH_STEP_DATA: 'FETCH_STEP_DATA',
  UPDATE_STEP_DATA: 'UPDATE_STEP_DATA',
};

export const fetchStepData = (flowId, mappedStep) => ({
  types: getApiActionTypesValues(USER_PAYMENT_FLOW.FETCH_STEP_DATA),
  promise: ({ client }) =>
    client.get(
      `/homeowners/user-payment/${flowId}/${mappedStep?.group?.key}/${mappedStep?.key}/${mappedStep?.uniqueId}`,
    ),
  auth: true,
});

export const updateStepData =
  (flowId, mappedStep, stepFormData) => (dispatch) =>
    dispatch({
      types: getApiActionTypesValues(USER_PAYMENT_FLOW.UPDATE_STEP_DATA),
      promise: ({ client }) =>
        client.put(
          `/homeowners/user-payment/${flowId}/${mappedStep.group.key}/${mappedStep.key}/${mappedStep.uniqueId}`,
          {
            ...stepFormData,
          },
        ),
      auth: true,
    });
